var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inline-flex justify-center items-center px-3 rounded-full text-xs font-medium leading-4 bg-gray-100 text-gray-800 w-full",class:{
    'bg-green-400': this.value,
    'bg-yellow-400': !this.value
  }},[_c('span',[_vm._v(" "+_vm._s(_vm.params.tag.labels[this.value ? 'true' : 'false'])+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }